<script>
    import {createEventDispatcher} from 'svelte';
    import Boton from "./Boton.svelte";

    const dispatch = createEventDispatcher();

    export let valor;
    export let max;
    export let min;

    const actualiza = (x, y) => {
        valor = Math.min(max, Math.max(min, parseInt(x, 10) + y));
        dispatch('cambio', valor);
    };

    const incrementa = () => actualiza(valor, 1);
    const decrementa = () => actualiza(valor, -1);
</script>

<style>
    .inputNumerico {
        display: flex;
        flex-direction: column;
        width: calc(10px + var(--padding-horizontal-botones) * 4);
        border-radius: var(--radio-global);
        overflow: hidden;
    }

    input {
        margin: 0;
        padding: .5em;
        display: block;
        width: 100%;
        -moz-appearance:textfield;
        text-align: center;
        font-size: 1em;
        font-family: var(--familia-monoespaciada);
        border: 1px solid var(--verde);
    }

    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }
</style>

<div class="inputNumerico">
    <Boton tamano="grande" on:click={incrementa} tipo="ok" radio={false}>
        <svg viewBox="0 0 10 10" width="10" height="10">
            <path d="M1 9L5 1L9 9" stroke="#fff" fill="none"></path>
        </svg>
    </Boton>

    <input type="number" value={valor.toString().padStart(2, '0')} {min} {max}
           on:input={e => actualiza(e.target.value, 0)} />

    <Boton tamano="grande" on:click={decrementa} tipo="ok" radio={false}>
        <svg viewBox="0 0 10 10" width="10" height="10">
            <path d="M1 1L5 9L9 1" stroke="#fff" fill="none"></path>
        </svg>
    </Boton>
</div>